export default "__VITE_ASSET__DANCdIPh__"